import { Injectable } from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class SetorAtivoService {    

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Origem do Cliente por id
     * @param id ID da Origem do Cliente
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "ativo/setor/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Origem do Cliente
     * @param id ID da Origem do Cliente
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "ativo/setor"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Origem do Cliente
     * @param id ID da Origem do Cliente
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "ativo/setor/search"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Ativo Para Campo Do Cadastro da Boleta
     */
    getLista(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "ativo/setor/lista", { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Ativo
     * @param id ID da Ativo
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "ativo/setor/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Ativo
     * @param params Json Ativo
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "ativo/setor", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Ativo
     * @param params Json Ativo
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "ativo/setor/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
